import { filter, includes } from "lodash";
import { PaymentStatus } from "../../PaymentContainerClient/commons/enums";
import PaymentDto from "../../PaymentContainerClient/dtos/PaymentDto";
import PaymentPlanDto from "../../PaymentContainerClient/dtos/PaymentPlanDto";

export default function getPaymentPlansWithAtLeastOnePaidOrScheduledOrOnHoldPayment(
    paymentPlans: PaymentPlanDto[],
    payments: PaymentDto[]
): PaymentPlanDto[] {
    return filter(paymentPlans, (paymentPlan) =>
        includes(
            filter(
                payments,
                (payment) =>
                    payment.status === PaymentStatus.Paid ||
                    payment.status === PaymentStatus.Scheduled ||
                    payment.status === PaymentStatus.OnHold
            ).map((payment) => payment.paymentPlanId),
            paymentPlan.id
        )
    );
}
